import TestsHeader from "./TestsHeader/TestsHeader";
import TestsBody from "./TestsBody/TestsBody";
import TestsFooter from "./TestsFooter/TestsFooter";
import { FC } from "react";

interface IProps {
  closeTests: () => void;
  zIndex: number;
  addTestOnRegistry?: boolean;
  shouldUpdateTestList?: () => void;
}

const Tests: FC<IProps> = ({ zIndex, addTestOnRegistry, closeTests, shouldUpdateTestList }) => {
  return (
    <div className="px-10 mx-auto w-full h-[100vh]">
      <TestsHeader />
      <TestsBody zIndex={zIndex} />
      <TestsFooter closeTests={closeTests} shouldUpdateTestList={shouldUpdateTestList} addTestOnRegistry={addTestOnRegistry} />
    </div>
  );
};
export default Tests;
